angular.module('bmsApp.employeeHoliday').controller('EmployeeHolidayCalendarCtrl', function ($scope,
																							 $modal,
																							 notify,
																							 uiCalendarConfig,
																							 EmployeeHolidaySvc,
																							 ConfigService) {

	var momentFormat = ConfigService.config.format.date.amDbDateTime;

	$scope.tabHoliday = function () {
		// need a timeout before rendering fc
		setTimeout(function () {
			uiCalendarConfig.calendars['holidayCalendar'].fullCalendar('render');
		}, 100);
	};

	var eventOverlap = true;
	if ($scope.employee) {
		eventOverlap = false;
	}

	$scope.uiConfig = {
		calendar: {
			height: '1200px',
			editable: true,
			selectable: true,
			eventOverlap: eventOverlap,
			header: {
				left: 'prev,next today',
				center: 'title',
				right: 'month,basicWeek,basicDay'
			},
			lang: 'en-GB',
			select: function (start, end, jsEvent, view) {
				var employee_holiday = {
//						employee: $scope.employee,
					start_date: start.clone().format(),
					start_time: 'all',
					end_date: end.clone().subtract(1, 'days').format(), // original BMS data has end_date as INCLUSIVE, should be EXCLUSIVE
					end_time: 'all'
				};
				if ($scope.employee) {
					employee_holiday.employee = $scope.employee;
				}
				$scope.employeeHolidayForm(employee_holiday);
			},
			eventClick: function (event, jsEvent, view) {
				var employee_holiday = event;
				$scope.employeeHolidayForm(employee_holiday);
			},
			eventDrop: function (event, delta, revertFunc, jsEvent, ui, view) {
				var employee_holiday = event;
				employee_holiday.start_date = event.start.clone().format();
				employee_holiday.end_date = event.end.clone().subtract(1, 'days').format(); // original BMS data has end_date as INCLUSIVE, should be EXCLUSIVE
				$scope.employeeHolidayForm(employee_holiday, revertFunc);
			},
			eventResize: function (event, delta, revertFunc, jsEvent, ui, view) {
				var employee_holiday = angular.copy(event);
				employee_holiday.start_date = event.start.clone().format();
				employee_holiday.end_date = event.end.clone().subtract(1, 'days').format(); // original BMS data has end_date as INCLUSIVE, should be EXCLUSIVE
				$scope.employeeHolidayForm(employee_holiday, revertFunc);
			}
		}
	};

	var holidays = {
		events: function (start, end, timezone, callback) {
			var config = {
				params: {
					start: start.format(momentFormat),
					end: end.format(momentFormat),
					activeEmployee: true
				}
			};
			if ($scope.employee) {
				EmployeeHolidaySvc.byEmployeeCalendar($scope.employee.id, config.params)
					.then(function (response) {
						events = response.data.employee_holidays;
						callback(events);
					}, function () {
						console.log('Failed to load employee holiday calendar');
					});
			}
			else {
				EmployeeHolidaySvc.allEmployeesCalendar(config.params)
					.then(function (response) {
						events = response.data.employee_holidays;
						callback(events);
					}, function () {
						console.log('Failed to load employee holidays calendar');
					});
			}
		}
	};

	$scope.eventSources = [holidays];

	$scope.employeeHolidayForm = function (employee_holiday, revertFunc) {

		if (angular.isUndefined(employee_holiday)) {
			employee_holiday = {
				start_date: moment().format(),
				end_date: moment().format(),
				start_time: 'all',
				end_time: 'all'
			};
			if ($scope.employee) {
				employee_holiday.employee = $scope.employee;
			}
		}

		var modalInstance = $modal.open({
			animation: true,
			templateUrl: 'ng/employee/employeeHoliday/templates/employeeHolidaySaveModal.html',
			controller: 'EmployeeHolidayModalFormCtrl',
			size: 'lg',
			scope: $scope,
			backdrop: 'static', // disable click-outside closing modal
			resolve: {
				employee_holiday: function () {
					return angular.copy(employee_holiday);
				}
			}
		});

		modalInstance.result.then(function (result) {
			if (result.success === true) {
				var message;
				switch (result.action) {
					case 'create':
						message = 'Holiday created successfully';
						break;
					case 'update':
						message = 'Holiday updated successfully';
						break;
					case 'delete':
						message = 'Holiday deleted successfully';
						break;
					default:
						message = 'Success';
						break;
				}
				notify({
					message: message
				});
			}
			else {
				notify({
					mesage: result.error,
					classes: 'error'
				});
			}
			// reload calendar
			uiCalendarConfig.calendars['holidayCalendar'].fullCalendar('refetchEvents');
		}, function () {
			if (angular.isUndefined(revertFunc) != true) {
				revertFunc();
			}
		});

	};

});
